export default __webpack_public_path__ + "static/media/ic_grenada.25931011.svg";